import { 
  IonIcon,
  IonLabel,
  IonRouterOutlet,
  IonTabBar,
  IonTabButton,
  IonTabs
} from '@ionic/react';
import React from 'react';
import { IonReactRouter } from '@ionic/react-router';
import { Route, Redirect, RouteComponentProps } from 'react-router-dom';
import { cubeOutline, cubeSharp, serverOutline, serverSharp, settingsOutline, settingsSharp
      
} from 'ionicons/icons';
import General from './settings/general/General';
import Accounts from './settings/accounts/Accounts';
import Account from './settings/accounts/Account';
import Modules from './settings/modules/Modules';
import SelectModule from './settings/modules/SelectModule';
import { withRouter } from "react-router";
import './Settings.css';

import { ServerService } from "../services/Server"

interface SettingPage {
  url: string;
  iosIcon: string;
  mdIcon: string;
  title: string;
  tab: string;
}

const server = new ServerService();

const settingPages: SettingPage[] = [
  {
    title: 'Accounts',
    url: '/accounts',
    iosIcon: serverOutline,
    mdIcon: serverSharp,
    tab:'accounts'
  },
/*  {
    title: 'Modules',
    url: '/modules',
    iosIcon: cubeOutline,
    mdIcon: cubeSharp,
    tab:'modules'
  }, */
  {
    title: 'Others',
    url: '/general',
    iosIcon: settingsOutline,
    mdIcon: settingsSharp,
    tab:'general'
   }
];

const Settings: React.FC<RouteComponentProps> = ({match, history}) => {

  server.setHistory(history);

  return (
      <IonReactRouter>
      <IonTabs>
        <IonRouterOutlet>
          <Route path={`${match.url}/:tab(accounts)`} component={Accounts} exact={true}/>
          <Route path={`${match.url}/:tab(accounts)/account/:id`} component={Account}/>
          {
          //<Route path={`${match.url}/:tab(modules)`} component={Modules} exact={true}/>
          //<Route path={`${match.url}/:tab(modules)/select/:id/:bid/:pageIdx`} component={SelectModule}/>
          }
          <Route path={`${match.url}/:tab(general)`} component={General} exact={true}/>
          <Route path={match.url} exact={true}>
            <Redirect to={`${match.url}/accounts`}/>
          </Route>
        </IonRouterOutlet>
        <IonTabBar slot="bottom">
          {settingPages.map((settingPage, index) => {
            return (
              <IonTabButton key={index} tab={settingPage.tab} href={`${match.url}${settingPage.url}`}>
              <IonIcon ios={settingPage.iosIcon} md={settingPage.mdIcon} />
              <IonLabel>{settingPage.title}</IonLabel>
              </IonTabButton>
            );
          })}
        </IonTabBar>
      </IonTabs>
      </IonReactRouter>
  );
};

export default withRouter(Settings);
